import {useAppTokens, type ThemeTokens} from '../theme'

interface BrandLogoProps {
  markSize?: number
  fontSize?: number
  gap?: number
}

const BrandLogo = ({markSize = 64, fontSize = 19, gap = 12}: BrandLogoProps) => {
  const tokens = useAppTokens()
  const styles = buildStyles(tokens, markSize, fontSize, gap)
  return (
    <span style={styles.root}>
      <span style={styles.mark}>
        <img src="/logo.svg" alt="" style={styles.markImg} />
      </span>
      <span style={styles.wordmark}>Ecranify</span>
    </span>
  )
}

const buildStyles = (tokens: ThemeTokens, markSize: number, fontSize: number, gap: number) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: `${gap}px`,
    color: tokens.text.primary,
    textDecoration: 'none',
  } as const,
  mark: {
    width: markSize,
    height: markSize,
    borderRadius: `${Math.max(2, markSize / 8)}px`,
    background: `linear-gradient(135deg, ${tokens.accent.lightest} 0%, ${tokens.accent.light} 30%, ${tokens.accent.primary} 65%, ${tokens.accent.dark} 100%)`,
    boxShadow: `0 0 20px ${tokens.accent.glow}, inset 0 1px 0 rgba(255, 255, 255, 0.25)`,
    overflow: 'hidden' as const,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  markImg: {
    width: '70%',
    height: '70%',
    objectFit: 'contain' as const,
    filter: 'brightness(0) invert(1)',
    display: 'block',
  } as const,
  wordmark: {
    fontWeight: 600,
    fontSize: `${fontSize}px`,
    letterSpacing: '-0.01em',
    color: tokens.text.primary,
    lineHeight: 1,
  } as const,
})

export default BrandLogo
